import { getBaseRole } from '@/helpers/customRoles';
import s from './collegesItem.module.css'
import { useState, useEffect, Fragment } from 'react'
import { useGetNameRole } from '@helpers/useGetNameRole'
import { getAvatar } from '@helpers/getAvatar'
import { useScreenWidth } from '@hooks/useScreenWidth'
import {
  EditIcoNewDesign,
  ExpandDropDownList,
  PlusIcon,
  DeleteIconEmployees,
  RatingIcon,
} from '@/utils/icons'
import { useInputNew } from '@UI/InputNew/useInputNew'
import { DatePicker, Select, Space, Tabs } from 'antd'
import { InputSelect } from '@UI/InputNew'
import { useAddAlert } from '@/hooks/useAddAlert'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import {
  usersAPI,
  directionOrdersApi,
  profileFieldsApi,
  departments as departmentsApi,
  teams as teamsApi,
} from '@/api'
import Modal from '@common/Modal'
import ModalAddTime from './modals/ModalAddTime'
import ModalAddContracts from './modals/ModalAddContracts'
import ModalEditAva from './modals/ModalEditAva'
import ModalAddDepartments from './modals/ModalAddDepartments'
import ModalAddTeams from './modals/ModalAddTeams'
import ModalAddRole from './modals/ModalAddRole'
import ModalChengeVks from './modals/ModalChengeVks'
import ModalAddDirection from './modals/ModalAddDirection'
import ModalRecoverPassword from './modals/ModalRecoverPassword'
import CreateGroupModal from '@pages/Admin/Manage/tabs/GroupsPage/components/CreateGroupModal/CreateGroupModal'
import { getInArr } from '@/helpers/getInArr'
import { IcoRemove } from '@pages/Admin/constsIcon'
import { useDispatch, useSelector } from 'react-redux'
import { actionUpdProfile, selectProfile } from '@store/profile.reducer'
import { AuthService } from '@/services/AuthService'
import Preloader from '@UI/Preloader'
import { formateDate } from '@helpers/date'
import Tooltip from '@UI/Tooltip'
import { useGetSettings } from '@pages/CoursesCatalog/tabs/CatalogCoursesTab/hooks/getPlatformSettings'
import SeniorSeminaristResponsibilitySelect from '../modals/CreateColleague/components/SeniorSeminaristResponsibilitySelect/SeniorSeminaristResponsibilitySelect'
import UpdateSeniorSeminarianSupervision from './modals/UpdateSeniorSeminarianSupervision/UpdateSeniorSeminarianSupervision'
import EmailVerifyWrapper from '@common/EmailVerifyWrapper/EmailVerifyWrapper'
import classNames from 'classnames'
import { getCorrectFilePath } from '@/helpers/new/getCorrectFilePath'
import { getMyLevel } from '@/helpers/getMyLevel'
import { getApiErrorMessage } from '@/helpers/getApiErrorMessage'
import { InputTextSaveCell } from '@pages/Admin/Reports/Payments/components/Cells/Cells'
import { updateUserRaring } from '@pages/Admin/Reports/UserRatingReport/utils/api'
import EditTeacherSalaryModal from '@pages/Admin/Manage/tabs/GroupsPage/components/EditTeacherSalaryModal/EditTeacherSalaryModal'
import RemoveDirectionModal from './modals/RemoveDirectionModal/RemoveDirectionModal'
import CrmSalesManagerConsequencesModal, {
  HEAD_OF_SALES_ROLE,
  SALES_MANAGER_ROLE,
  isCrmSalesConsequenceRole,
  userHasCrmSalesConsequenceRole,
  userHasHeadOfSalesRole,
  userHasSalesManagerRole,
} from './modals/CrmSalesManagerConsequencesModal/CrmSalesManagerConsequencesModal'
import { checkHeadOfSalesSoleProjectAdmin } from './modals/CrmSalesManagerConsequencesModal/checkHeadOfSalesSoleProjectAdmin'
import EditIndividualTeacherModal from '@pages/Admin/Manage/tabs/IndividualStudentsPage/components/EditTeacherModal/EditTeacherModal'
import { formatTeacherSalaryShort } from '@pages/Admin/Manage/tabs/GroupsPage/utils/teacherSalary'
import FranchiseSelect from '@common/FranchiseSelect/FranchiseSelect'
import { useFranchises } from '@/hooks/useFranchises'
import { getEmployeeProfileFields, getEmployeeBirthDateUpdate } from '@/helpers/employeeProfileFields'
import { isTruthySetting } from '@/helpers/studentProfileFields'
import { WorkHoursSchedule } from '@common/WorkHours'
import { LiveDigitalLinkHint } from '@common/LiveDigitalLinkHint'
import {
  PROFILE_FIELD_ENTITY_TYPES,
  getProfileFieldValue,
  getProfileFieldValuesPayload,
  getProfileFieldValuesResponseData,
  getProfileFieldsResponseData,
  setProfileFieldValue,
} from '@/helpers/profileFields'
dayjs.extend(customParseFormat)

const formatLastActionTime = (time) => {
  if (!time) return 'нет активности'

  const date = new Date(time)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${day}.${month}.${year}, ${hours}:${minutes}`
}

let rateChangeTimeoutGroup1 = null
let rateChangeTimeout1 = null

const getEmployeeGamificationRole = (user) => {
  const roles = user?.roles?.map((role) => role?.item_name ?? role?.role) ?? []

  if (roles.some((role) => getBaseRole(role) === 'seminarian')) return 'seminarian'
  if (roles.some((role) => getBaseRole(role) === 'senior-seminarian')) return 'senior-seminarian'

  return 'seminarian'
}

export const CollegesItemEdit = ({
  setEdit,
  edit,
  setState,
  big,
  user: initialUser = null,
}) => {
  const { checkSettings, getSettings } = useGetSettings()
  const { items: franchiseItems } = useFranchises()
  const [profileApiFields, setProfileApiFields] = useState([])
  const [customFieldValues, setCustomFieldValues] = useState({})
  const employeeProfileFields = getEmployeeProfileFields(
    {},
    profileApiFields,
    true,
  )
  const customEmployeeFields = employeeProfileFields.filter(
    (field) => field.isCustom && isTruthySetting(field.is_active, true),
  )
  const isEmployeeFieldEnabled = (fieldId, legacySetting) => {
    const field = employeeProfileFields.find((item) => item.id === fieldId)
    if (field?.profileFieldId) return isTruthySetting(field.is_active, true)
    return checkSettings(legacySetting)
  }
  const showPhone = isEmployeeFieldEnabled('phone', 'showPhoneColleagues')
  const showEmail = isEmployeeFieldEnabled('email', 'showEmailColleagues')
  const showLogin = isEmployeeFieldEnabled('login', 'showLoginColleagues')
  const emailField = employeeProfileFields.find((field) => field.id === 'email')
  const isEmailRequired = showEmail && isTruthySetting(emailField?.required, true)
  const showGender = isEmployeeFieldEnabled('sex', 'showGenderColleagues')
  const showBirthDate = isEmployeeFieldEnabled(
    'birthDate',
    'showBirthDateColleagues',
  )
  const showCity = isEmployeeFieldEnabled('city', 'showCityColleagues')
  const showRegistrationAddress = isEmployeeFieldEnabled(
    'address',
    'showRegistrationAddressColleagues',
  )
  const showEducation = isEmployeeFieldEnabled(
    'education',
    'showEducationColleagues',
  )
  const showWorkExperience = isEmployeeFieldEnabled(
    'experience',
    'showWorkExperienceColleagues',
  )
  const showSocialLink = isEmployeeFieldEnabled(
    'socialLink',
    'showSocialLinkColleagues',
  )
  const showVksLink = isEmployeeFieldEnabled(
    'conferenceLink',
    'showVksLinkColleagues',
  )
  const isSeparateLinksForStudentsAndTeachers = checkSettings(
    'isSeparateLinksForStudentsAndTeachers',
  )
  const showAboutMe = isEmployeeFieldEnabled('about', 'showAboutMeColleagues')
  const showDepartments = isEmployeeFieldEnabled(
    'departments',
    'showDepartmentsColleagues',
  )
  const showRating = isEmployeeFieldEnabled('rating', 'showRatingColleagues')
  const showWorkSchedule = isEmployeeFieldEnabled(
    'workSchedule',
    'showWorkScheduleColleagues',
  )
  const showContracts = isEmployeeFieldEnabled(
    'contracts',
    'showContractsColleagues',
  )
  const isSettingEnabledByDefault = (key) => getSettings(key) !== '0'
  const showGamificationExperience = isSettingEnabledByDefault(
    'showGamificationExperienceColleagues',
  )
  const showGamificationBalance = isSettingEnabledByDefault(
    'showGamificationBalanceColleagues',
  )
  const seniorSeminarianManager = checkSettings(
    'isSeniorSeminarianManageCoursesClasses',
  )

  const roleAndDepartmentsText = showDepartments ? 'Роли и отделы' : 'Роли'

  const settings = useSelector(store => store.settings)
  useEffect(() => {
    profileFieldsApi
      .index({ entity_type: PROFILE_FIELD_ENTITY_TYPES.EMPLOYEE })
      .then((response) => {
        setProfileApiFields(getProfileFieldsResponseData(response))
      })
      .catch(() => setProfileApiFields([]))
  }, [])
  useEffect(() => {
    if (!edit) return

    profileFieldsApi
      .values({
        user_id: edit,
        entity_type: PROFILE_FIELD_ENTITY_TYPES.EMPLOYEE,
      })
      .then((response) => {
        setCustomFieldValues(getProfileFieldValuesResponseData(response))
      })
      .catch(() => setCustomFieldValues({}))
  }, [edit])
  const userIdsAllowedToDeleteEmployee = settings.userIdsAllowedToDeleteEmployee
    ? JSON.parse(settings.userIdsAllowedToDeleteEmployee)
    : []
  const selectEmployeesWhoAreAllowedDeleteEmployees =
    settings.selectEmployeesWhoAreAllowedDeleteEmployees === '1'
  const hideTeacherRatingInCard =
    settings.hideTeacherRatingInCard === '1' ||
    !showRating

  const [user, setUser] = useState([])
  const employeeGamificationRole = getEmployeeGamificationRole(
    user?.id ? user : initialUser,
  )
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    usersAPI
      .getUser({
        id: edit,
        expand: [
          'roles',
          'contracts',
          'userProfile',
          'workHours',
          'orgUnits.head',
          'teams.head',
          'groups_supervisor',
          'classes_supervisor',
          'franchises',
        ],
        role: getEmployeeGamificationRole(initialUser),
      })
      .then((res) => {
        setUser(res.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [edit])

  const profile = useSelector(selectProfile)
  const allowAdministrativeActions =
    getBaseRole(profile?.role) === 'admin' ||
    getBaseRole(profile?.role) === 'hr-manager' ||
    getBaseRole(profile?.role) === 'junior-admin'
  const allowEditing =
    allowAdministrativeActions ||
    getBaseRole(profile?.role) === 'franchise-manager'

  const dispatch = useDispatch()

  const addAlert = useAddAlert()

  const dateFormat = 'YYYY.MM.DD'
  const isMobile = useScreenWidth(767)

  const [name, setName] = useState(user?.name ?? '')
  const [departments, setDepartments] = useState(user?.orgUnits ?? [])
  const [teams, setTeams] = useState(user?.teams ?? [])
  const [contracts, setContracts] = useState(user?.contracts ?? [])
  const [userId, setUserId] = useState(user?.id)
  const [phone, setPhone] = useState(user?.phone ?? '')
  const [email, setEmail] = useState(user?.email ?? '')
  const [login, setLogin] = useState(user?.login ?? '')
  const [promoCode, setPromoCode] = useState(user?.promo_code ?? '')
  const [sex, setSex] = useState(user?.userProfile?.sex)
  const [birthDate, setBirthDate] = useState(
    user?.userProfile?.birth_date ?? '',
  )
  const [city, setCity] = useState(user?.userProfile?.city ?? '')
  const [address, setAddress] = useState(user?.userProfile?.address ?? '')
  const [education, setEducation] = useState(user?.userProfile?.education ?? '')
  const [experience, setExperience] = useState(
    user?.userProfile?.experience ?? '',
  )
  const [urlConference, setUrlConference] = useState(
    user?.userProfile?.url_conference ?? '',
  )
  const [urlConferenceForChildren, setUrlConferenceForChildren] = useState(
    user?.userProfile?.url_conference_for_children ?? '',
  )
  const [telebosRoomId, setTelebosRoomId] = useState(
    user?.userProfile?.telebos_room_id ?? '',
  )
  const [linkToVk, setLinkToVk] = useState(user?.userProfile?.link_to_vk ?? '')
  const [about, setAbout] = useState(user?.userProfile?.about ?? '')
  const [status, setStatus] = useState(user?.status)
  const [avatarPath, setAvatarPath] = useState(user?.avatar_path)
  const [roles, setRoles] = useState(user?.roles)
  const [workHours, setWorkHours] = useState(user?.workHours)
  const [createdAt, setCreatedAt] = useState(user?.created_at)
  const [lvlState, setLvlState] = useState(user?.pulses ?? 0)
  const [franchiseIds, setFranchiseIds] = useState(user?.franchise_ids ?? [])
  const [balanceState, setBalanceState] = useState(
    user?.gamification_balance ?? user?.pulses ?? 0,
  )

  useEffect(() => {
    setName(user?.name ?? '')
    setDepartments(user?.orgUnits ?? [])
    setTeams(user?.teams ?? [])
    setContracts(user?.contracts ?? [])
    setUserId(user?.id)
    setPhone(user?.phone ?? '')
    setEmail(user?.email ?? '')
    setLogin(user?.login ?? '')
    setPromoCode(user?.promo_code ?? '')
    setSex(user?.userProfile?.sex)
    setBirthDate(user?.userProfile?.birth_date ?? '')
    setCity(user?.userProfile?.city ?? '')

    setAddress(user?.userProfile?.address ?? '')
    setEducation(user?.userProfile?.education ?? '')
    setExperience(user?.userProfile?.experience ?? '')
    setUrlConference(user?.userProfile?.url_conference ?? '')
    setUrlConferenceForChildren(
      user?.userProfile?.url_conference_for_children ?? '',
    )
    setTelebosRoomId(user?.userProfile?.telebos_room_id ?? '')
    setLinkToVk(user?.userProfile?.link_to_vk ?? '')
    setAbout(user?.userProfile?.about ?? '')
    setStatus(user?.status)
    setAvatarPath(user?.avatar_path)
    setRoles(user?.roles)
    setWorkHours(user?.workHours)
    setCreatedAt(user?.created_at)
    setLvlState(user?.pulses ?? 0)
    setFranchiseIds(user?.franchise_ids ?? [])
    setBalanceState(user?.gamification_balance ?? user?.pulses ?? 0)
  }, [user])

  const [tabActive, setTabActive] = useState('employee')
  const [isModalActiveAddTime, setIsModalActiveAddTime] = useState(false)
  const [isModalActiveAddСontracts, setIsModalActiveAddСontracts] =
    useState(false)
  const [isModalActiveAddDepartments, setIsModalActiveAddDepartments] =
    useState(false)
  const [isModalActiveAddTeams, setIsModalActiveAddTeams] = useState(false)
  const [isModalActiveAddRole, setIsModalActiveAddRole] = useState(false)
  const [isModalActiveAddDirection, setIsModalActiveAddDirection] =
    useState(false)
  const [isModalActiveEditAva, setIsModalActiveEditAva] = useState(false)
  const [isModalActiveRecoverPassword, setIsModalActiveRecoverPassword] =
    useState(false)
  const [isModalActiveChengeVks, setIsModalActiveChengeVks] = useState(false)

  const [isModalActiveAddGroup, setIsModalActiveAddGroup] = useState(false)
  const [addGroupIdDerection, setAddGroupIdDerection] = useState(null)

  const [visible, setVisible] = useState(true)
  const [allowEditingName, setAllowEditingName] = useState(false)

  const [hasVksChanged, setHasVksChanged] = useState(false)

  const [bindSex] = useInputNew({
    name: 'sex',
    value: sex,
    defaultValue: true,
    onChange: (e) => setSex(e),
    placeholder: 'Пол',
    options: [
      { label: 'Женский', value: 'female' },
      { label: 'Мужской', value: 'male' },
    ],
  })

  const onChangeDate = (date, dateString) => {
    setBirthDate(dateString)
  }

  //получаем пользователя
  const [subjects, setSubjects] = useState([])

  const getSeminarianDirection = () =>
    usersAPI
      .directionBySeminarian({
        id: user.id,
        params: { expand: 'direction.directionGroups,seminarian' },
      })
      .then(async (res) => {
        const nextSubjects =
          res?.data?.data.map(
            ({
              id: linkId,
              direction: { name, id, directionGroups },
              rate,
              rate_group,
            }) => ({
              id,
              name,
              linkId,
              rate,
              rate_group,
              directionGroups,
            }),
          ) ?? []
        // ponytail: один существующий запрос на курс; batch endpoint нужен только при измеримой задержке карточки.
        const subjectsWithStudents = await Promise.all(
          nextSubjects.map((subject) =>
            directionOrdersApi
              .getPrivateOwners(user.id, subject.id, 0, 1)
              .then((studentsRes) => ({
                ...subject,
                futurePrivateStudents: Array.isArray(studentsRes?.data)
                  ? studentsRes.data
                  : studentsRes?.data?.data ?? [],
              }))
              .catch(() => ({ ...subject, futurePrivateStudents: [] })),
          ),
        )

        setSubjects(subjectsWithStudents)
      })
  useEffect(() => {
    if (user?.id !== undefined) {
      getSeminarianDirection()
    }
  }, [user?.id])

  const changeRate = (value, linkId) => {
    if (value > -1) {
      setSubjects((state) => {
        return state.map((el) => {
          if (el?.linkId == linkId) {
            return {
              ...el,
              rate: Number(value),
            }
          }
          return el
        })
      })

      clearTimeout(rateChangeTimeout1)

      rateChangeTimeout1 = setTimeout(() => {
        usersAPI
          .changeDirection({
            id: linkId,
            data: { rate: Number(value) },
          })
          .then((res) => {
            if (res.data.status === 'success') {
              addAlert({ text: 'Ставка успешно установлена' })
            }
          })
      }, 500)
    } else {
      addAlert({
        type: 'error',
        title: 'Вводить можно только числа',
        text: 'Вводить можно только числа',
      })
    }
  }

  const changeRateGroup = (value, linkId) => {
    if (value > -1) {
      setSubjects((state) => {
        return state.map((el) => {
          if (el?.linkId == linkId) {
            return {
              ...el,
              rate_group: Number(value),
            }
          }
          return el
        })
      })

      clearTimeout(rateChangeTimeoutGroup1)

      rateChangeTimeoutGroup1 = setTimeout(() => {
        usersAPI
          .changeDirection({
            id: linkId,
            data: { rate_group: Number(value) },
          })
          .then((res) => {
            if (res.data.status === 'success') {
              addAlert({ text: 'Ставка успешно установлена' })
            }
          })
      }, 500)
    } else {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Вводить можно только числа',
      })
    }
  }

  const deleteRoles = (value) => {
    const newRoles = roles?.filter((el) => {
      return !(value == el?.item_name)
    })

    return usersAPI
      .updateRoles({
        id: userId,
        data: { roles: newRoles },
      })
      .then((res) => {
        if (res.data.status === 'success') {
          update('roles')
          addAlert({ title: 'Роль успешно удалена' })
          return true
        }
        return false
      })
  }

  const deleteDirection = (value) =>
    usersAPI.removeDirection({ id: value }).then((res) => {
      if (res?.data?.status !== 'success') {
        // Причину отказа уже показал глобальный обработчик ошибок.
        getSeminarianDirection()
        return false
      }

      setSubjects((state) => {
        return state.filter((el) => el.linkId !== value)
      })
      addAlert({ text: 'Курс успешно удален' })
      return true
    })

  const update = (params = '') => {
    if (params == 'direction') {
      getSeminarianDirection()
    }

    if (params == 'workHours') {
      usersAPI.getUser({ id: userId, expand: ['workHours'] }).then((res) => {
        setWorkHours(res.data.workHours)
      })
    }
    if (params == 'contracts') {
      usersAPI.getUser({ id: userId, expand: ['contracts'] }).then((res) => {
        setContracts(res.data.contracts)
        setStateUpdate({
          contracts: res.data.contracts,
        })
      })
    }
    if (params == 'departments') {
      usersAPI
        .getUser({ id: userId, expand: ['orgUnits.head'] })
        .then((res) => {
          setDepartments(res.data.orgUnits)
          setStateUpdate({
            orgUnits: res.data.orgUnits,
          })
        })
    }
    if (params == 'teams') {
      usersAPI.getUser({ id: userId, expand: ['teams.head'] }).then((res) => {
        setTeams(res.data.teams)
        setStateUpdate({
          teams: res.data.teams,
        })
      })
    }
    if (params == 'roles') {
      usersAPI.getUser({ id: userId, expand: ['roles'] }).then((res) => {
        setRoles(res.data.roles)
        setStateUpdate({
          roles: res.data.roles,
        })
      })
    }
  }

  const deleteContracts = (id) => {
    usersAPI.removeContract({ id }).then((res) => {
      update('contracts')
    })
  }

  const deleteEmployee = (idUser, idDepartment) => {
    departmentsApi
      .deleteEmployee({
        userId: idUser,
        unitId: idDepartment,
      })
      .then((res) => {
        if (res.data === true) {
          update('departments')
          addAlert({ text: 'Сотрудник удален из отдела' })
        }
      })
  }

  const deleteEmployeeFromTeam = (userId, teamId) => {
    teamsApi
      .deleteEmployee({
        userId: userId,
        teamId: teamId,
      })
      .then((res) => {
        if (res.data === true) {
          update('teams')
          addAlert({ text: 'Сотрудник удален из команды' })
        }
      })
  }

  const setStateUpdate = (newData = {}) => {
    if (!setState) return
    setState((state) => {
      return state?.map((el) => {
        if (el?.id === edit) {
          return {
            ...el,
            ...newData,
          }
        } else {
          return el
        }
      })
    })
  }
  const save = async (updateVks = false) => {
    const birthDateValue = birthDate.replace(/\./g, '-')
    if (![email, phone, login].some((value) => String(value ?? '').trim())) {
      addAlert({
        type: 'error',
        title: 'Укажите E-mail, телефон или логин',
      })
      return
    }
    if (isEmailRequired && !String(email ?? '').trim()) {
      addAlert({ type: 'error', title: 'Укажите E-mail' })
      return
    }

      const initialFranchiseIds = (user?.franchise_ids ?? []).map(Number).sort()
      const selectedFranchiseIds = franchiseIds.map(Number).sort()
      if (
        JSON.stringify(initialFranchiseIds) !==
          JSON.stringify(selectedFranchiseIds) &&
        !window.confirm(
          'Точно ли вы уверены, что хотите сохранить данный филиал у данного пользователя?',
        )
      ) {
        return
      }
      usersAPI
        .upd({
          id: userId,
          data: {
            ...getEmployeeBirthDateUpdate(birthDate, user?.userProfile?.birth_date),
            email: email,
            phone: phone,
            login: login,
            promo_code: promoCode,
            sex: sex,
            city: city,
            address: address,
            education: education,
            experience: experience,
            url_conference: urlConference,
            url_conference_for_children: urlConferenceForChildren,
            telebos_room_id: telebosRoomId,
            link_to_vk: linkToVk,
            about: about,
            name: name,
            roles: roles,
            update_vks: updateVks,
            franchise_ids: franchiseIds,
          },
          expand: ['roles'],
        })

        .then(async (res) => {
          if (res.data.status === 'success') {
            const savedUser = res.data?.data ?? {}
            const savedFranchiseIds =
              savedUser.franchise_ids ?? franchiseIds
            const savedFranchises =
              savedUser.franchises ??
              franchiseItems
                .filter((item) =>
                  savedFranchiseIds.map(Number).includes(Number(item.id)),
                )
                .map((item) => ({ id: item.id, name: item.name }))
            try {
              const valuesResponse = await profileFieldsApi.saveValues({
                user_id: userId,
                entity_type: PROFILE_FIELD_ENTITY_TYPES.EMPLOYEE,
                custom_fields: getProfileFieldValuesPayload(
                  customEmployeeFields,
                  customFieldValues,
                ),
              })
              setCustomFieldValues(
                getProfileFieldValuesResponseData(valuesResponse),
              )
            } catch {
              addAlert({
                type: 'error',
                title: 'Ошибка сохранения дополнительных полей',
              })
            }
            setHasVksChanged(false)
            addAlert({ title: 'Профиль изменен' })
            const updatedUser = {
              name,
              phone,
              email,
              login,
              promo_code: promoCode,
              franchise_ids: savedFranchiseIds,
              franchises: savedFranchises,
              userProfile: {
                ...user.userProfile,
                birth_date: birthDateValue || null,
                sex,
                city,
                address,
                education,
                experience,
                url_conference: urlConference,
                url_conference_for_children: urlConferenceForChildren,
                telebos_room_id: telebosRoomId,
                link_to_vk: linkToVk,
                about,
              },
            }
            setUser((prev) => ({ ...prev, ...updatedUser }))
            setStateUpdate(updatedUser)
          } else {
            const error = res.data?.error
            addAlert({
              type: 'error',
              title: 'Упс! Ошибка',
              text: Array.isArray(error)
                ? error[0]
                : getApiErrorMessage(res, 'Попробуйте ещё раз или обратитесь к администратору'),
            })
          }
        })

      if (userId === profile.id) {
        dispatch(
          actionUpdProfile({
            ...profile,
            userProfile: {
              ...profile.userProfile,
              url_conference: urlConference,
              url_conference_for_children: urlConferenceForChildren,
              telebos_room_id: telebosRoomId,
            },
          }),
        )
      }
  }

  const cancellation = () => {
    setEdit(null)
  }

  const updateCustomField = (field, value) => {
    setCustomFieldValues((prev) => setProfileFieldValue(prev, field, value))
  }

  const renderCustomField = (field) => {
    const value = getProfileFieldValue(customFieldValues, field) ?? ''

    if (field.type === 'select') {
      return (
        <Select
          key={field.name}
          className={s.city}
          popupClassName="newSelectPopup"
          placeholder={field.label}
          value={value || undefined}
          allowClear
          options={(field.value_options ?? []).map((option) => ({
            label: option,
            value: option,
          }))}
          onChange={(nextValue) => updateCustomField(field, nextValue ?? '')}
        />
      )
    }

    if (field.type === 'date') {
      return (
        <Space key={field.name} direction="vertical" className={s.birthDate}>
          <DatePicker
            onChange={(date, dateString) => updateCustomField(field, dateString)}
            value={value ? dayjs(String(value).replace(/-/gi, '.'), dateFormat) : null}
            format={dateFormat}
            className={`backgroundNone ${s.birthDateValue}`}
            placeholder={field.label}
          />
        </Space>
      )
    }

    return (
      <input
        key={field.name}
        placeholder={field.label}
        className={`backgroundNone ${s.city}`}
        type={field.type === 'number' ? 'number' : 'text'}
        value={value}
        onInput={(event) => updateCustomField(field, event.currentTarget.value)}
      />
    )
  }

  const renderCustomTextarea = (field) => (
    <textarea
      key={field.name}
      placeholder={field.label}
      value={getProfileFieldValue(customFieldValues, field) ?? ''}
      onInput={(event) => updateCustomField(field, event.currentTarget.value)}
      className={`backgroundNone ${s.about}`}
    />
  )

  const authorization = async () => {
    try {
      const response = await usersAPI.authorization(userId)

      if(response?.data?.user?.id){
        AuthService.auth(
          response.data.user,
          response.data.token,
          response.data?.refresh_token,
        )
        window.location.href = '/'
      } else {
        addAlert({ title: 'Ошибка', text: 'При входе в ЛК произошла ошибка', type: 'error' })
      }
    } catch (error) {
      addAlert({
        title: 'Ошибка',
        text: getApiErrorMessage(error, 'При входе в ЛК произошла ошибка'),
        type: 'error',
      })
    }
  }

  const [salesManagerConfirm, setSalesManagerConfirm] = useState(null)
  const [salesManagerConfirmLoading, setSalesManagerConfirmLoading] =
    useState(false)
  const [salesManagerConfirmChecking, setSalesManagerConfirmChecking] =
    useState(false)

  const openCrmSalesConsequenceConfirm = async ({ mode, roleName }) => {
    const roleKinds =
      mode === 'remove-role' && roleName
        ? [roleName]
        : [
            ...(userHasHeadOfSalesRole(roles) ? [HEAD_OF_SALES_ROLE] : []),
            ...(userHasSalesManagerRole(roles) ? [SALES_MANAGER_ROLE] : []),
          ]

    const needsRopCheck = roleKinds.includes(HEAD_OF_SALES_ROLE)

    setSalesManagerConfirm({
      mode,
      roleName,
      roleKinds,
      blocked: false,
      projectTitle: undefined,
    })

    if (!needsRopCheck) return

    setSalesManagerConfirmChecking(true)
    try {
      const check = await checkHeadOfSalesSoleProjectAdmin(userId)
      setSalesManagerConfirm((prev) =>
        prev
          ? {
              ...prev,
              blocked: Boolean(check.blocked),
              projectTitle: check.projectTitle,
            }
          : prev,
      )
    } catch {
      // Если проверка не удалась — показываем предупреждение, блок оставит бэк.
      setSalesManagerConfirm((prev) =>
        prev ? { ...prev, blocked: false } : prev,
      )
    } finally {
      setSalesManagerConfirmChecking(false)
    }
  }

  const performDisableUser = () =>
    usersAPI.disable({ id: userId }).then((res) => {
      if (res.data.status === 'success') {
        setVisible(false)
        addAlert({ text: 'Сотрудник успешно уволен' })
        return true
      }
      return false
    })

  const deleteUser = () => {
    if (
      !userIdsAllowedToDeleteEmployee.includes(profile.id) &&
      selectEmployeesWhoAreAllowedDeleteEmployees
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Вам запрещено выполнять это действие',
      })
      return
    }
    if (userHasCrmSalesConsequenceRole(roles)) {
      void openCrmSalesConsequenceConfirm({ mode: 'dismiss' })
      return
    }
    void performDisableUser()
  }

  const handleSalesManagerConfirm = async () => {
    if (
      !salesManagerConfirm ||
      salesManagerConfirmLoading ||
      salesManagerConfirmChecking ||
      salesManagerConfirm.blocked
    ) {
      return
    }

    setSalesManagerConfirmLoading(true)
    try {
      let ok = false
      if (salesManagerConfirm.mode === 'dismiss') {
        ok = Boolean(await performDisableUser())
      } else if (
        salesManagerConfirm.mode === 'remove-role' &&
        salesManagerConfirm.roleName
      ) {
        ok = Boolean(await deleteRoles(salesManagerConfirm.roleName))
      }
      if (ok) {
        setSalesManagerConfirm(null)
      }
    } catch {
      // ошибку уже показал глобальный обработчик API
    } finally {
      setSalesManagerConfirmLoading(false)
    }
  }
  const restoreUser = () => {
    if (
      !userIdsAllowedToDeleteEmployee.includes(profile.id) &&
      selectEmployeesWhoAreAllowedDeleteEmployees
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Вам запрещено выполнять это действие',
      })
      return
    }
    usersAPI.restore({ id: userId }).then((res) => {
      if (res.data.status === 'success') {
        setVisible(false)
        addAlert({ text: 'Сотрудник успешно восстановлен' })
      }
    })
  }

  const [openGroups, setOpenGroups] = useState([])
  const [salaryEditGroup, setSalaryEditGroup] = useState(null)
  const [teacherEditStudent, setTeacherEditStudent] = useState(null)
  const [removeDirectionSubject, setRemoveDirectionSubject] = useState(null)
  const [isSalaryEditAllGroupsOpen, setIsSalaryEditAllGroupsOpen] =
    useState(false)

  useEffect(() => {
    setOpenGroups(subjects?.map((subject) => subject?.id) ?? [])
  }, [subjects])

  const getTeacherDirectionGroups = (directionGroups = []) => {
    return (
      directionGroups?.filter(
        (group) => Number(group?.teacher_id) === Number(userId),
      ) ?? []
    )
  }

  const hasSeminarianRole = getInArr(
    'seminarian',
    roles?.map((el) => el.item_name) ?? [],
  )
  const isTelebosIntegrationEnabled =
    settings.isTelebosIntegrationEnabled == '1' ||
    settings.isTelebosIntegrationEnabled === true
  const showTelebosRoomId = isTelebosIntegrationEnabled && hasSeminarianRole

  const renderExpandedGroupRows = (
    directionGroups = [],
    hasFuturePrivateStudents = false,
  ) => {
    const teacherGroups = getTeacherDirectionGroups(directionGroups)

    if (!teacherGroups.length) {
      if (hasFuturePrivateStudents) return null

      return (
        <div className={s.groupExpandedRow}>
          <div className={s.groupExpandedName}>-</div>
          <div className={s.groupExpandedSpacer}></div>
          <div className={s.groupExpandedSalary}>-</div>
        </div>
      )
    }

    return teacherGroups.map((group) => {
      const salaryValue = formatTeacherSalaryShort({
        type: group?.teacher_salary?.type,
        salary: group?.teacher_salary?.salary,
        durationMinutes: group?.teacher_salary?.duration_minutes,
      })

      if (!allowEditing) {
        return (
          <div key={group?.id} className={s.groupExpandedRow}>
            <div className={s.groupExpandedName}>{group?.name}</div>
            <div className={s.groupExpandedSpacer}></div>
            <div className={s.groupExpandedSalary}>
              <div className={s.groupSalaryCellReadonly}>{salaryValue}</div>
            </div>
          </div>
        )
      }

      return (
        <div key={group?.id} className={s.groupExpandedRow}>
          <div className={s.groupExpandedName}>{group?.name}</div>
          <div className={s.groupExpandedSpacer}></div>
          <div className={s.groupExpandedSalary}>
            <InputTextSaveCell
              value={salaryValue}
              className={s.groupSalaryCell}
                              styles={{ width: '100%', backgroundColor: 'var(--color-button-neutral-bg)' }}
              onChange={() => {}}
              onStartEdit={() => setSalaryEditGroup(group)}
            />
          </div>
        </div>
      )
    })
  }

  const renderFuturePrivateStudentRows = (subject) =>
    (subject?.futurePrivateStudents ?? []).map((student, index) => {
      const item = {
        index,
        student: {
          id: Number(student?.value),
          name: student?.label,
        },
        teacher: user,
        course: {
          id: Number(subject?.id),
          name: subject?.name,
        },
      }

      return (
        <div
          key={`private-${subject?.id}-${student?.value}`}
          className={s.groupExpandedRow}
        >
          <div className={s.groupExpandedName}>
            {student?.label}
            <div className={s.itemRolesColumn1GroupsItem}>
              Индивидуальный ученик
            </div>
          </div>
          <div className={s.groupExpandedSpacer}></div>
          <div className={s.groupExpandedSalary}>
            {['admin', 'junior-admin'].includes(getBaseRole(profile?.role)) && (
              <button
                onClick={() => setTeacherEditStudent(item)}
                className={`backgroundNewGrey ${s.salaryAllGroupsInlineButton}`}
              >
                Сменить педагога
              </button>
            )}
          </div>
        </div>
      )
    })

  const openGroupsToggle = (id) => {
    if (openGroups.includes(id)) {
      setOpenGroups((state) => {
        return state.filter((el) => {
          return !(el === id)
        })
      })
    } else {
      setOpenGroups((state) => {
        return [...state, id]
      })
    }
  }

  const [seniorSeminarianIdModal, setSeniorSeminarianIdModal] = useState(null)
  const onChangeSeniorSeminarianResp = (classes, groups) => {
    setSeniorSeminarianIdModal(null)
    setUser((prev) => {
      return { ...prev, classes_supervisor: classes, groups_supervisor: groups }
    })
  }

  if (loading) {
    return <Preloader fullScreen="center" />
  }

  const parseLevels = (value) => {
    try {
      return value ? JSON.parse(value) : undefined
    } catch (error) {
      return undefined
    }
  }

  const level = getMyLevel(
    user?.pulses ?? 0,
    parseLevels(
      settings?.custom?.teacherLevelSettings ??
        settings?.teacherLevelSettings ??
        settings?.studentLevelSettings,
    ),
  )

  const updateRating = async () => {
    const res = (
      await updateUserRaring(
        user?.id,
        lvlState,
        undefined,
        employeeGamificationRole,
      )
    ).success

    if (res) {
      addAlert({ title: 'Рейтинг обновлен' })
      setUser((prev) => ({ ...prev, pulses: lvlState }))
      setStateUpdate({ pulses: lvlState })
    } else {
      addAlert({
        title: 'Ошибка при сохранении рейтинга',
        type: 'error',
      })
    }

    return res
  }

  const updateGamificationBalance = async () => {
    const res = (
      await updateUserRaring(
        user?.id,
        user?.pulses ?? 0,
        balanceState,
        employeeGamificationRole,
      )
    ).success

    if (res) {
      addAlert({ title: 'Игровая валюта обновлена' })
      setUser((prev) => ({ ...prev, gamification_balance: balanceState }))
      setStateUpdate({ gamification_balance: balanceState })
    } else {
      addAlert({
        title: 'Ошибка при сохранении игровой валюты',
        type: 'error',
      })
    }

    return res
  }

  return (
    <>
      <div
        style={{
          borderBottom:
            big || (status != 0 && allowEditing)
              ? '0px solid var(--color-border-inverse)'
              : '1px solid var(--color-border-subtle)',
          display: visible ? 'flex' : 'none',
        }}
        className={classNames(s.item, { [s.itemBig]: big })}
      >
        <div className={s.firstState} style={{ alignItems: 'flex-start' }}>
          <div className={s.avatar}>
            <img src={getAvatar(user, true, avatarPath)} alt="" />
            {allowEditing && (
              <div
                className={s.editAva}
                onClick={() => {
                  setIsModalActiveEditAva(true)
                }}
              >
                <EditIcoNewDesign />
              </div>
            )}
          </div>

          <div className={`${s.info} ${s.infoEdit}`}>
            <div className={`${s.name} ${s.nameEdit}`}>
              {allowEditingName ? (
                <input
                  style={{ width: '100%' }}
                  value={name}
                  className={`backgroundNone`}
                  onInput={(e) => {
                    setName(e.currentTarget.value)
                  }}
                />
              ) : (
                name
              )}
              {allowEditing && (
                <div className={s.infoAndEditName}>
                  {allowEditingName ? (
                    <DeleteIconEmployees
                      onClick={() => {
                        setAllowEditingName((state) => !state)
                      }}
                    />
                  ) : (
                    <EditIcoNewDesign
                      onClick={() => {
                        setAllowEditingName((state) => !state)
                      }}
                    />
                  )}
                </div>
              )}
            </div>
            <div className={s.userHeaderLastActiveContainer}>
              <div className={s.userHeaderLastActiveDot} />
              <span>{formatLastActionTime(user?.last_login)}</span>
            </div>
          </div>
          <div className={s.registrationDate}>
            {!hideTeacherRatingInCard && showGamificationExperience && (
              <div className="backgroundNone">Уровень: {level.lvl}</div>
            )}
            <div className="backgroundNone">
              Дата регистрации: {formateDate(new Date(createdAt * 1000))}
            </div>
          </div>
        </div>
        <div className={s.contentEdit}>
          <Tabs
            className={s.tabs}
            activeKey={tabActive}
            onChange={setTabActive}
            items={[
              { key: 'employee', label: 'О сотруднике' },
              { key: 'roles', label: roleAndDepartmentsText },
              ...(showContracts
                ? [{ key: 'contracts', label: 'Договор' }]
                : []),
              ...(showWorkSchedule
                ? [{ key: 'timetable', label: 'Рабочее расписание' }]
                : []),
            ]}
          />
          {tabActive === 'employee' && (
            <div className={s.employee}>
              <FranchiseSelect
                value={franchiseIds}
                onChange={setFranchiseIds}
                required
                multiple={getBaseRole(profile?.role) !== 'franchise-manager'}
                disabled={getBaseRole(profile?.role) === 'franchise-manager'}
              />
              {showPhone && (
                <input
                  placeholder="Телефон"
                  className={`backgroundNone ${s.phone}`}
                  value={phone}
                  onInput={(e) => {
                    setPhone(e.currentTarget.value)
                  }}
                />
              )}
              {showEmail && (
                <EmailVerifyWrapper
                  visible={settings.requireEmployeeEmailConfirmation === '1'}
                  verified={user?.is_email_confirmed === 1}
                  style={
                    big
                      ? { width: 'auto', minWidth: '220px', flex: '1 1 220px' }
                      : { width: 'calc(20% - 4px)' }
                  }
                >
                  <input
                    placeholder="E-mail"
                    className={`backgroundNone ${s.emeil}`}
                    value={email}
                    onInput={(e) => {
                      setEmail(e.currentTarget.value)
                    }}
                    style={{ width: '100%' }}
                  />
                </EmailVerifyWrapper>
              )}
              {showLogin && (
                <input
                  placeholder="Логин"
                  className={`backgroundNone ${s.phone}`}
                  value={login}
                  onInput={(e) => {
                    setLogin(e.currentTarget.value)
                  }}
                />
              )}
              <input
                placeholder="Реферальный промокод"
                className={`backgroundNone ${s.phone}`}
                value={promoCode}
                onInput={(e) => setPromoCode(e.currentTarget.value)}
              />
              {showGender && (
                <InputSelect className={s.sex} newDesign={true} {...bindSex} />
              )}
              {showBirthDate && (
                <Space direction="vertical" className={s.birthDate}>
                  <DatePicker
                    onChange={onChangeDate}
                    value={
                      birthDate
                        ? dayjs(birthDate.replace(/-/gi, '.'), dateFormat)
                        : null
                    }
                    //defaultValue={dayjs(birthDate.replace(/-/gi, "."), dateFormat)}
                    format={dateFormat}
                    className={`backgroundNone ${s.birthDateValue}`}
                  />
                </Space>
              )}
              {showCity && (
                <input
                  placeholder="Город"
                  className={`backgroundNone ${s.city}`}
                  value={city}
                  onInput={(e) => {
                    setCity(e.currentTarget.value)
                  }}
                />
              )}
              {showRegistrationAddress && (
                <input
                  placeholder="Адрес регистрации"
                  className={`backgroundNone ${s.address}`}
                  value={address}
                  onInput={(e) => {
                    setAddress(e.currentTarget.value)
                  }}
                />
              )}
              {showEducation && (
                <input
                  placeholder="Образование"
                  className={`backgroundNone ${s.education}`}
                  value={education}
                  onInput={(e) => {
                    setEducation(e.currentTarget.value)
                  }}
                />
              )}
              {showWorkExperience && (
                <input
                  placeholder="Опыт работы"
                  className={`backgroundNone ${s.experience}`}
                  value={experience}
                  onInput={(e) => {
                    if (e.currentTarget.value > -1) {
                      setExperience(e.currentTarget.value)
                    }
                  }}
                />
              )}
              {!hideTeacherRatingInCard && showGamificationExperience && (
                <div className={`backgroundNone ${s.employeeRatingValue}`}>
                  <span>Опыт:</span>
                  <RatingIcon style={{ minWidth: '24px', minHeight: '24px' }} />
                  <InputTextSaveCell
                    value={String(lvlState)}
                    className={s.inputTextSaveCell}
                    onChange={(value) => {
                      setLvlState(Number(value))
                    }}
                    onSave={updateRating}
                    type="number"
                  />
                </div>
              )}
              {!hideTeacherRatingInCard && showGamificationBalance && (
                <div className={`backgroundNone ${s.employeeRatingValue}`}>
                  <span>Игровая валюта:</span>
                  <RatingIcon style={{ minWidth: '24px', minHeight: '24px' }} />
                  <InputTextSaveCell
                    value={String(balanceState)}
                    className={s.inputTextSaveCell}
                    onChange={(value) => {
                      setBalanceState(Number(value))
                    }}
                    onSave={updateGamificationBalance}
                    type="number"
                  />
                </div>
              )}
              {showVksLink && (
                <>
                  <div className={`${s.urlConference} ${s.vksField}`}>
                    <input
                      placeholder="Ссылка на ВКС"
                      className="backgroundNone"
                      value={urlConference}
                      onInput={(e) => {
                        setUrlConference(e.currentTarget.value)
                        setHasVksChanged(true)
                      }}
                    />
                    <LiveDigitalLinkHint value={urlConference} />
                  </div>
                  {isSeparateLinksForStudentsAndTeachers && (
                    <div className={`${s.urlConference} ${s.vksField}`}>
                      <input
                        placeholder="Ссылка на ВКС(для учащихся)"
                        className="backgroundNone"
                        value={urlConferenceForChildren}
                        onInput={(e) => {
                          setUrlConferenceForChildren(e.currentTarget.value)
                          setHasVksChanged(true)
                        }}
                      />
                      <LiveDigitalLinkHint
                        value={urlConferenceForChildren}
                        forChildren
                      />
                    </div>
                  )}
                </>
              )}
              {showTelebosRoomId && (
                <input
                  placeholder="ID комнаты Telebos"
                  className={`backgroundNone ${s.urlConference}`}
                  value={telebosRoomId}
                  onInput={(e) => {
                    setTelebosRoomId(e.currentTarget.value)
                  }}
                />
              )}
              {showSocialLink && (
                <input
                  placeholder="Ссылка на соц сеть"
                  className={`backgroundNone ${s.linkToVk}`}
                  value={linkToVk}
                  onInput={(e) => {
                    setLinkToVk(e.currentTarget.value)
                  }}
                />
              )}
              {!isMobile && showAboutMe && (
                <div className={s.titleEdit}>О себе:</div>
              )}
              {showAboutMe && (
                <textarea
                  placeholder={isMobile ? 'О себе' : 'Информация о себе'}
                  disabled={true}
                  value={about}
                  onInput={(e) => {
                    setAbout(e.currentTarget.value)
                  }}
                  className={`backgroundNone ${s.about}`}
                />
              )}
              {customEmployeeFields
                .filter((field) => field.type !== 'textarea')
                .map(renderCustomField)}
              {customEmployeeFields
                .filter((field) => field.type === 'textarea')
                .map(renderCustomTextarea)}
            </div>
          )}
          {tabActive === 'roles' && (
            <div className={s.roles}>
              {showDepartments && (
                <div className={s.departmentsWrapper}>
                  <div className={s.itemDepartment}>
                    <div className={s.itemDepartmentColumn1}>
                      <span className={s.columnTitle}>Отдел</span>
                    </div>
                    <div className={s.itemDepartmentColumn2}>
                      <span className={s.columnTitle}>Руководитель</span>
                    </div>
                    <div className={s.itemDepartmentColumn3}>
                      {allowEditing && (
                        <button
                          onClick={() => {
                            setIsModalActiveAddDepartments(true)
                          }}
                          style={{ marginLeft: 'auto', fontWeight: '600' }}
                          className={`${s.buttonAdd} backgroundNewGrey`}
                        >
                          {isMobile && <PlusIcon />}
                          {!isMobile ? `Добавить отдел` : ''}
                        </button>
                      )}
                    </div>
                  </div>
                  {departments?.map((item) => {
                    return (
                      <div key={item?.id} className={s.itemDepartment}>
                        <div className={s.itemDepartmentColumn1}>
                          {item?.name}
                        </div>
                        <div className={s.itemDepartmentColumn2}>
                          {item?.head?.name && (
                            <button
                              className={`backgroundNone ${s.backgroundNoneMobile}`}
                            >
                              {item?.head?.name}
                            </button>
                          )}
                        </div>
                        {allowEditing && (
                          <div
                            className={`${s.itemDepartmentColumn3} ${s.buttonDelete}`}
                            onClick={() => {
                              if (
                                window.confirm(
                                  'Вы уверены, что хотите удалить отдел у сотрудника?',
                                )
                              ) {
                                deleteEmployee(userId, item.id)
                              }
                            }}
                          >
                            {!isMobile ? (
                              `Удалить`
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9"
                                height="10"
                                viewBox="0 0 9 10"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                                  fill="var(--color-text-strong)"
                                />
                              </svg>
                            )}
                            {!isMobile && <DeleteIconEmployees />}
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              )}
              <div className={s.rolesWrapper}>
                <div className={s.itemRoles}>
                  <div className={s.itemRolesColumn1}>
                    <span className={s.columnTitle}>Роль</span>
                  </div>
                  {!isMobile && (
                    <>
                      <div className={s.itemRolesColumn2}>
                        <div className={s.groupColumnHeader}>
                          <span
                            style={{ textAlign: 'center' }}
                            className={s.columnTitle}
                          >
                            Ставка / мин (индивид)
                          </span>
                          <Tooltip
                            text="Вы можете задать стандартную стоимость индивидуального занятия для каждого предмета у данного педагога.
При необходимости эту ставку можно изменить для конкретного ученика. Заполнение поля позволяет автоматически подставлять стоимость при добавлении учащегося и не забывать, сколько вы платите педагогу."
                            width={220}
                          />
                        </div>
                      </div>
                      <div className={s.itemRolesColumn3}>
                        <div className={s.groupColumnHeader}>
                          <span
                            style={{ textAlign: 'center' }}
                            className={s.columnTitle}
                          >
                            За группу (занятие)
                          </span>
                        </div>
                      </div>
                      <div
                        className={`${s.itemRolesColumn4} ${s.itemRolesColumn4Fix}`}
                        style={{ flexDirection: 'column' }}
                      >
                        {allowEditing && (
                          <button
                            onClick={() => {
                              setIsModalActiveAddRole(true)
                            }}
                            className="backgroundNewGrey"
                          >
                            Добавить роль
                          </button>
                        )}

                        {getInArr('seminarian', [
                          ...roles?.map((el) => {
                            return el.item_name
                          }),
                        ]) &&
                          allowEditing && (
                            <button
                              onClick={() => {
                                setIsModalActiveAddDirection(true)
                              }}
                              className="backgroundNewGrey"
                            >
                              Добавить курс
                            </button>
                          )}
                      </div>
                      <Tooltip
                        text="Чтобы педагог мог вести занятия по какому-либо курсу необходимо не только дать ему роль педагога, но и указать курсы, в которых он может преподавать"
                        width={220}
                      />
                    </>
                  )}
                  {isMobile && (
                    <div
                      className={`${s.itemRolesRigthmob} new-design-scroll new-design-scroll6`}
                    >
                      <div className={s.itemRolesColumn2}>
                        <div className={s.groupColumnHeader}>
                          <span
                            style={{ textAlign: 'center' }}
                            className={s.columnTitle}
                          >
                            Ставка / мин (индивид)
                          </span>
                          <Tooltip
                            text="Вы можете задать стандартную стоимость индивидуального занятия для каждого предмета у данного педагога.
При необходимости эту ставку можно изменить для конкретного ученика. Заполнение поля позволяет автоматически подставлять стоимость при добавлении учащегося и не забывать, сколько вы платите педагогу."
                            width={220}
                          />
                        </div>
                      </div>
                      <div className={s.itemRolesColumn3}>
                        <div className={s.groupColumnHeader}>
                          <span
                            style={{ textAlign: 'center' }}
                            className={s.columnTitle}
                          >
                            За группу (занятие)
                          </span>
                        </div>
                      </div>
                      <div className={s.itemRolesColumn4}>
                        {allowEditing && (
                          <button
                            onClick={() => {
                              setIsModalActiveAddRole(true)
                            }}
                            className="backgroundNewGrey"
                          >
                            Добавить роль
                          </button>
                        )}

                        {getInArr('seminarian', [
                          ...roles?.map((el) => {
                            return el.item_name
                          }),
                        ]) &&
                          allowEditing && (
                            <button
                              onClick={() => {
                                setIsModalActiveAddDirection(true)
                              }}
                              className="backgroundNewGrey"
                            >
                              Добавить курс
                            </button>
                          )}
                      </div>
                    </div>
                  )}
                </div>
                {roles?.map((role, i) => {
                  if (getBaseRole(role.item_name) === 'seminarian' && subjects?.length) {
                    return subjects?.map((subject, subjectIndex) => {
                      return (
                        <div key={subject?.id} className={s.itemRoles}>
                          <div className={s.itemRolesColumn1}>
                            Педагог: {subject.name}
                            <div className={s.itemRolesColumn1Group}>
                              Группы и индивидуальные ученики{' '}
                              <ExpandDropDownList
                                style={{
                                  transform: openGroups.includes(subject?.id)
                                    ? 'rotate(90deg)'
                                    : 'rotate(0deg)',
                                }}
                                onClick={() => {
                                  openGroupsToggle(subject?.id)
                                }}
                              />
                            </div>
                          </div>
                          {!isMobile && (
                            <>
                              <div className={s.itemRolesColumn2}>
                                <div className={s.salaryRateColumn}>
                                  <input
                                    disabled={!allowEditing}
                                    style={{ width: '100%' }}
                                    className="backgroundNone"
                                    value={subject.rate ?? ''}
                                    onChange={(e) => {
                                      changeRate(
                                        e.currentTarget.value,
                                        subject.linkId,
                                      )
                                    }}
                                  />
                                </div>
                              </div>
                              <div className={s.itemRolesColumn3}>
                                <div className={s.salaryRateColumn}>
                                  {allowEditing && (
                                    <button
                                      onClick={() => {
                                        setIsSalaryEditAllGroupsOpen(true)
                                      }}
                                      className={`backgroundNewGrey ${s.salaryAllGroupsInlineButton}`}
                                    >
                                      Изменить для всех групп
                                    </button>
                                  )}
                                  <div
                                    className={s.groupSalaryColumnStub}
                                  ></div>
                                </div>
                              </div>

                              {allowEditing && (
                                <div
                                  className={`${s.itemRolesColumn4} ${s.itemRolesColumn4Fix} ${s.buttonDelete}`}
                                  onClick={() =>
                                    setRemoveDirectionSubject(subject)
                                  }
                                >
                                  {!isMobile ? (
                                    `Удалить`
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="9"
                                      height="10"
                                      viewBox="0 0 9 10"
                                      fill="none"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                                        fill="var(--color-text-strong)"
                                      />
                                    </svg>
                                  )}
                                  {!isMobile && <DeleteIconEmployees />}
                                </div>
                              )}
                            </>
                          )}
                          {isMobile && (
                            <div
                              className={`${s.itemRolesRigthmob} new-design-scroll new-design-scroll6`}
                            >
                              <div className={s.itemRolesColumn2}>
                                <div className={s.salaryRateColumn}>
                                  <input
                                    disabled={!allowEditing}
                                    style={{ width: '100%' }}
                                    className="backgroundNone"
                                    value={subject.rate ?? ''}
                                    onChange={(e) => {
                                      changeRate(
                                        e.currentTarget.value,
                                        subject.linkId,
                                      )
                                    }}
                                  />
                                </div>
                              </div>
                              <div className={s.itemRolesColumn3}>
                                <div className={s.salaryRateColumn}>
                                  {allowEditing && (
                                    <button
                                      onClick={() => {
                                        setIsSalaryEditAllGroupsOpen(true)
                                      }}
                                      className={`backgroundNewGrey ${s.salaryAllGroupsInlineButton}`}
                                    >
                                      Изменить для всех групп
                                    </button>
                                  )}
                                  <div
                                    className={s.groupSalaryColumnStub}
                                  ></div>
                                </div>
                              </div>

                              {allowEditing && (
                                <div
                                  className={`${s.itemRolesColumn4} ${s.buttonDelete}`}
                                  onClick={() =>
                                    setRemoveDirectionSubject(subject)
                                  }
                                >
                                  {!isMobile ? (
                                    `Удалить`
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="9"
                                      height="10"
                                      viewBox="0 0 9 10"
                                      fill="none"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                                        fill="var(--color-text-strong)"
                                      />
                                    </svg>
                                  )}
                                  {!isMobile && <DeleteIconEmployees />}
                                </div>
                              )}
                            </div>
                          )}
                          {openGroups.includes(subject?.id) && (
                            <div className={s.groupExpandedRows}>
                              {renderExpandedGroupRows(
                                subject?.directionGroups,
                                !!subject?.futurePrivateStudents?.length,
                              )}
                              {renderFuturePrivateStudentRows(subject)}
                              {allowEditing && (
                                <div className={s.groupExpandedRow}>
                                  <button
                                    onClick={() => {
                                      setIsModalActiveAddGroup(true)
                                      setAddGroupIdDerection(subject?.id)
                                    }}
                                    className={s.itemRolesColumn1GroupsItemAdd}
                                  >
                                    Создать
                                  </button>
                                  <div className={s.groupExpandedSpacer}></div>
                                  <div className={s.groupExpandedSalary}></div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )
                    })
                  }
                  return (
                    <div className={s.itemRoleWrapper}>
                      <div className={s.itemRoleContent}>
                        <div className={s.itemRolesColumn1}>
                          <UserRole role={role} />
                        </div>
                        {!isMobile && (
                          <>
                            <div className={s.itemRolesColumn2}></div>
                            <div className={s.itemRolesColumn3}></div>
                          </>
                        )}
                        {allowEditing && (
                          <div
                            className={`${s.itemRolesColumn4} ${s.itemRolesColumn4Fix} ${s.buttonDelete} ${roles?.length <= 1 ? s.buttonDeleteDisabled : ''}`}
                            title={
                              roles?.length <= 1
                                ? 'Нельзя удалить последнюю роль пользователя'
                                : undefined
                            }
                            onClick={() => {
                              if (roles?.length <= 1) {
                                addAlert({
                                  type: 'error',
                                  title: 'Нельзя удалить последнюю роль пользователя',
                                })
                                return
                              }
                              if (isCrmSalesConsequenceRole(role.item_name)) {
                                void openCrmSalesConsequenceConfirm({
                                  mode: 'remove-role',
                                  roleName: role.item_name,
                                })
                                return
                              }
                              if (
                                window.confirm(
                                  'Вы уверены, что хотите удалить роль?',
                                )
                              ) {
                                deleteRoles(role.item_name)
                              }
                            }}
                          >
                            {!isMobile ? (
                              roles?.length <= 1
                                ? 'Последнюю роль удалить нельзя'
                                : 'Удалить'
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9"
                                height="10"
                                viewBox="0 0 9 10"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                                  fill="var(--color-text-strong)"
                                />
                              </svg>
                            )}
                            {!isMobile && <DeleteIconEmployees />}
                          </div>
                        )}
                      </div>
                      {seniorSeminarianManager &&
                        getBaseRole(role.item_name) === 'senior-seminarian' && (
                          <>
                            <div
                              className={s.seniorSeminarianCoursesClassesField}
                              onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                setSeniorSeminarianIdModal(user.id)
                              }}
                              onMouseDown={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                            >
                              <SeniorSeminaristResponsibilitySelect
                                selectedClasses={user?.classes_supervisor ?? []}
                                selectedGroups={user?.groups_supervisor ?? []}
                                onChange={() => {}}
                              />
                            </div>
                            <UpdateSeniorSeminarianSupervision
                              visible={!!seniorSeminarianIdModal}
                              userId={seniorSeminarianIdModal}
                              onSuccess={onChangeSeniorSeminarianResp}
                              onDismiss={() => setSeniorSeminarianIdModal(null)}
                            />
                          </>
                        )}
                    </div>
                  )
                })}
              </div>
            </div>
          )}
          {tabActive === 'contracts' && showContracts && (
            <div className={s.contracts}>
              <div className={s.contractsItem}>
                <div
                  className={`${s.contractsItemLeft} ${s.contractsItemLeftTitle}`}
                >
                  <div
                    style={{ marginTop: '0px' }}
                    className={`${s.contractsItemTilte} ${s.titleEdit}`}
                  >
                    {isMobile ? 'Название' : 'Название договора'}
                  </div>
                  <div
                    style={{
                      marginTop: '0px',
                      marginLeft: 'auto',
                      width: 'auto',
                    }}
                    className={`${s.contractsItemTilte} ${s.contractsItemTilteFile} ${s.titleEdit}`}
                  >
                    Файл
                  </div>
                  {isMobile && allowEditing && (
                    <button
                      onClick={() => {
                        setIsModalActiveAddСontracts(true)
                      }}
                      className={`backgroundNewGrey ${s.buttonAdd}`}
                    >
                      <PlusIcon />
                    </button>
                  )}
                </div>
                {!isMobile && allowEditing && (
                  <div
                    className={`${s.contractsItemRight} ${s.contractsItemRightFix}`}
                  >
                    <button
                      onClick={() => {
                        setIsModalActiveAddСontracts(true)
                      }}
                      className="backgroundNewGrey"
                    >
                      Добавить договор
                    </button>
                  </div>
                )}
              </div>

              {contracts?.map((item) => (
                <div key={item?.id} className={s.contractsItem}>
                  <div className={s.contractsItemLeft}>
                    <div
                      style={{ marginTop: '0px' }}
                      className={`${s.contractsItemTilte} ${s.titleEdit}`}
                    >
                      {item.name}
                    </div>
                    <a
                      target="_blank"
                      href={getCorrectFilePath(item.file_path)}
                      className={`backgroundNone ${s.contractsItemFile}`}
                    >
                      Файл загружен
                    </a>
                    {isMobile && allowEditing && (
                      <div
                        style={{ paddingRight: '0px' }}
                        className={`${s.contractsItemRight} ${s.buttonDelete}`}
                        onClick={() => {
                          if (
                            window.confirm(
                              'Вы уверены, что хотите удалить договор?',
                            )
                          ) {
                            deleteContracts(item?.id)
                          }
                        }}
                      >
                        {!isMobile ? (
                          `Удалить`
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="10"
                            viewBox="0 0 9 10"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                              fill="var(--color-text-strong)"
                            />
                          </svg>
                        )}
                        {!isMobile && <DeleteIconEmployees />}
                      </div>
                    )}
                  </div>
                  {!isMobile && allowEditing && (
                    <div
                      style={{ paddingRight: '0px' }}
                      className={`${s.contractsItemRight} ${s.buttonDelete}`}
                      onClick={() => {
                        if (
                          window.confirm(
                            'Вы уверены, что хотите удалить договор?',
                          )
                        ) {
                          deleteContracts(item?.id)
                        }
                      }}
                    >
                      {!isMobile ? (
                        `Удалить`
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                            fill="var(--color-text-strong)"
                          />
                        </svg>
                      )}
                      {!isMobile && <DeleteIconEmployees />}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {tabActive === 'timetable' && showWorkSchedule && (
            <div className={s.timetable}>
              <WorkHoursSchedule
                workHours={workHours}
                editable={allowEditing}
                onEdit={() => setIsModalActiveAddTime(true)}
              />
            </div>
          )}
        </div>
        {allowEditing && (
          <div className={s.actionsWithTheUser}>
            {status != 0 && (
              <button
                onClick={() => {
                  if (hasVksChanged) {
                    setIsModalActiveChengeVks(true)
                  } else {
                    save()
                  }
                }}
                style={{
                  borderLeft: 'none',
                  borderTopLeftRadius: '0px',
                  borderTopRightRadius: '0px',
                }}
                className={`${s.actionsWithTheUserButton} ${s.actionsWithTheUserButtonSave}`}
              >
                Сохранить
              </button>
            )}
            {status != 0 && (
              <button
                onClick={cancellation}
                style={{
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={s.actionsWithTheUserButton}
              >
                Закрыть
              </button>
            )}
            {allowAdministrativeActions && status != 0 && (
              <button
                onClick={() => {
                  setIsModalActiveRecoverPassword(true)
                }}
                style={{
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={`${s.actionsWithTheUserButton} ${s.actionsWithTheUserButtonPassword}`}
              >
                Сбросить пароль
              </button>
            )}
            {allowAdministrativeActions && status != 0 && (
              <button
                onClick={authorization}
                style={{
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={`${s.actionsWithTheUserButton} ${s.actionsWithTheUserButtonAuthorization}`}
              >
                Авторизоваться
              </button>
            )}
            {allowAdministrativeActions && status != 0 && (
              <button
                onClick={deleteUser}
                disabled={
                  !userIdsAllowedToDeleteEmployee.includes(profile.id) &&
                  selectEmployeesWhoAreAllowedDeleteEmployees
                }
                style={{
                  borderRight: 'none',
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={`${s.actionsWithTheUserButton} ${s.actionsWithTheUserButtonDelete}`}
              >
                Уволить
              </button>
            )}
            {allowAdministrativeActions && status == 0 && (
              <button
                onClick={restoreUser}
                disabled={
                  !userIdsAllowedToDeleteEmployee.includes(profile.id) &&
                  selectEmployeesWhoAreAllowedDeleteEmployees
                }
                style={{
                  borderBottom: 'none',
                  borderLeft: 'none',
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={s.actionsWithTheUserButton}
              >
                Восстановить
              </button>
            )}
          </div>
        )}
        {!allowEditing && status != 0 && (
          <div className={s.actionsWithTheUser}>
            <button
              onClick={cancellation}
              style={{
                borderTopRightRadius: '0px',
                borderTopLeftRadius: '0px',
                borderBottom: '0px',
                borderLeft: '0px',
              }}
              className={s.actionsWithTheUserButton}
            >
              Закрыть
            </button>
          </div>
        )}
      </div>
      {isModalActiveAddTime && (
        <Modal
          active={isModalActiveAddTime}
          setActive={() => setIsModalActiveAddTime(false)}
        >
          <ModalAddTime
            setActive={setIsModalActiveAddTime}
            userId={userId}
            update={update}
            workHours={workHours}
          />
        </Modal>
      )}
      {isModalActiveAddСontracts && (
        <Modal
          active={isModalActiveAddСontracts}
          setActive={() => setIsModalActiveAddСontracts(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddСontracts(false)}
          />
          <ModalAddContracts
            setActive={setIsModalActiveAddСontracts}
            userId={userId}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveAddDepartments && (
        <Modal
          active={isModalActiveAddDepartments}
          setActive={() => setIsModalActiveAddDepartments(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddDepartments(false)}
          />
          <ModalAddDepartments
            setActive={setIsModalActiveAddDepartments}
            userId={userId}
            departments={departments}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveAddTeams && (
        <Modal
          active={isModalActiveAddTeams}
          setActive={() => setIsModalActiveAddTeams(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddTeams(false)}
          />
          <ModalAddTeams
            setActive={setIsModalActiveAddTeams}
            userId={userId}
            teams={teams}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveAddRole && (
        <Modal
          active={isModalActiveAddRole}
          setActive={() => setIsModalActiveAddRole(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddRole(false)}
          />
          <ModalAddRole
            setActive={setIsModalActiveAddRole}
            userId={userId}
            rolesUser={roles}
            update={update}
            franchiseIds={franchiseIds}
          />
        </Modal>
      )}
      {isModalActiveAddDirection && (
        <Modal
          active={isModalActiveAddDirection}
          setActive={() => setIsModalActiveAddDirection(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddDirection(false)}
          />
          <ModalAddDirection
            setActive={setIsModalActiveAddDirection}
            userId={userId}
            subjects={subjects}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveRecoverPassword && (
        <Modal
          active={isModalActiveRecoverPassword}
          setActive={() => setIsModalActiveRecoverPassword(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveRecoverPassword(false)}
          />
          <ModalRecoverPassword
            setActive={setIsModalActiveRecoverPassword}
            userId={userId}
          />
        </Modal>
      )}
      {isModalActiveEditAva && (
        <Modal
          active={isModalActiveEditAva}
          setActive={() => setIsModalActiveEditAva(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveEditAva(false)}
          />
          <ModalEditAva
            setActive={setIsModalActiveEditAva}
            userId={userId}
            setAvatarPath={setAvatarPath}
            avatarPath={avatarPath}
            setStateUpdate={setStateUpdate}
          />
        </Modal>
      )}
      <CreateGroupModal
        open={isModalActiveAddGroup}
        directionId={addGroupIdDerection}
        teacherId={userId}
        onClose={() => setIsModalActiveAddGroup(false)}
        onSuccess={() => {
          update('direction')
          setIsModalActiveAddGroup(false)
        }}
      />
      {isModalActiveChengeVks && (
        <Modal
          active={isModalActiveChengeVks}
          setActive={() => setIsModalActiveChengeVks(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveChengeVks(false)}
          />
          <ModalChengeVks setActive={setIsModalActiveChengeVks} save={save} />
        </Modal>
      )}
      <EditTeacherSalaryModal
        teacher={user}
        group={salaryEditGroup}
        teacherSalary={salaryEditGroup?.teacher_salary}
        duration={salaryEditGroup?.teacher_salary?.duration_minutes}
        open={!!salaryEditGroup}
        onClose={() => setSalaryEditGroup(null)}
        onSuccess={() => {
          getSeminarianDirection()
          setSalaryEditGroup(null)
        }}
      />
      <EditTeacherSalaryModal
        teacher={user}
        mode="all-groups"
        hasLessonPaymentGroups={subjects?.some((subject) =>
          getTeacherDirectionGroups(subject?.directionGroups).some((group) =>
            group?.type === 'lesson-payment' || group?.group_type === 'lesson-payment',
          ),
        )}
        open={isSalaryEditAllGroupsOpen}
        onClose={() => setIsSalaryEditAllGroupsOpen(false)}
        onSuccess={() => {
          getSeminarianDirection()
          setIsSalaryEditAllGroupsOpen(false)
        }}
      />
      <RemoveDirectionModal
        subject={removeDirectionSubject}
        groups={getTeacherDirectionGroups(
          removeDirectionSubject?.directionGroups,
        )}
        teacherId={userId}
        open={!!removeDirectionSubject}
        onClose={() => setRemoveDirectionSubject(null)}
        onConfirm={() => deleteDirection(removeDirectionSubject?.linkId)}
      />
      <CrmSalesManagerConsequencesModal
        open={!!salesManagerConfirm}
        mode={salesManagerConfirm?.mode ?? 'dismiss'}
        roleKinds={
          salesManagerConfirm?.roleKinds ??
          (salesManagerConfirm?.roleName
            ? [salesManagerConfirm.roleName]
            : [SALES_MANAGER_ROLE])
        }
        blocked={Boolean(salesManagerConfirm?.blocked)}
        projectTitle={salesManagerConfirm?.projectTitle}
        checking={salesManagerConfirmChecking}
        loading={salesManagerConfirmLoading}
        onDismiss={() => {
          if (salesManagerConfirmLoading || salesManagerConfirmChecking) return
          setSalesManagerConfirm(null)
        }}
        onConfirm={() => {
          void handleSalesManagerConfirm()
        }}
      />
      <EditIndividualTeacherModal
        item={teacherEditStudent}
        open={!!teacherEditStudent}
        onClose={() => setTeacherEditStudent(null)}
        onSuccess={() => {
          getSeminarianDirection()
          setTeacherEditStudent(null)
        }}
      />
    </>
  )
}

const UserRole = ({ role }) => useGetNameRole(role)

export default CollegesItemEdit
